import * as React from 'react';
import * as ReactDOM from "react-dom/client";
import { Route, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { AuthProvider } from 'react-oidc-context';
import { BaseContainer } from './containers/base-container';
import { config } from './config';
import { LandingPageContainer } from './containers/landing-page-container';
import { SymbolPageContainer } from './containers/symbol-page-container';
import { OrdersPageContainer } from './containers/orders-page-container';
import { PortfolioPageContainer } from './containers/portfolio-page-container';
import { ClosedPositionsPageContainer } from './containers/closed-positions-page-container';

const cognitoAuthConfig = {
	authority: config.authConfig.authority,
	client_id: config.authConfig.client_id,
	redirect_uri: config.authConfig.redirect_uri,
	response_type: config.authConfig.response_type,
	scope: config.authConfig.scope,
};

export const renderRouter = (mountPoint: Element) => {
	const router = (
		<React.StrictMode>
			<AuthProvider {...cognitoAuthConfig}>
				<Provider store={store}>
					<BrowserRouter>
						<BaseContainer>
							<Route exact path='/' component={LandingPageContainer} />
							<Route exact path='/symbol/:symbol' component={SymbolPageContainer} />
							<Route exact path='/orders/' component={OrdersPageContainer} />						<Route exact path='/closed-positions/' component={ClosedPositionsPageContainer} />							<Route exact path='/portfolio/' component={PortfolioPageContainer} />
						</BaseContainer>
					</BrowserRouter>
				</Provider>
			</AuthProvider>
		</React.StrictMode>
	);

	ReactDOM.createRoot(mountPoint).render(router);
};